<template>
	<article>
    <header class="view__header">
      <h2 class="view__title">{{ L.localize("Members_Breadcrumb_History") }}</h2>
    </header>
    <article class="view__content">
      <div class="view__panelflex">
        <submenu />

        <div id="member-subscriptions" v-if="memberPaymentOptions && memberPaymentOptions.length">
          <h3 class="view__title--sub">{{ L.localize("Members_Breadcrumb_History") }}</h3>
          <div class="options-list">
            <div class="options-list__item" v-for="(subscription, index) in memberPaymentOptions">
              <div class="options-list__content">
                <h4 class="options-list__title">{{ subscription.name }}</h4>
                <h6 class="options-list__subtitle">
                  {{ Format.date(subscription.startDate, 'LL') }} - {{ Format.date(subscription.endDate, 'LL') }}
                </h6>
              </div>
              <div class="options-list__control">
                <Btn label="Label_CancelButton" :withBorder="true" @click="cancelSubscription(subscription.paymentOptionId)" />
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <h3 class="view__title--sub">{{ L.localize("Label_NoSubscriptions") }}</h3>
          <SelectList label="Label_PaymentOptions" v-model="selectPaymentOptionId" :options="paymentOptionsOptions" :acc="acc.generate('payment-options')" />
          <Btn label="Label_Add" :acc="acc.generate('add-subscription')" @click="addSubscription(selectPaymentOptionId)" />
        </div>

        <div id="member-invoices" v-if="memberInvoices.length >= 1">
          <h3 class="view__title--sub">{{ L.localize("Label_Invoices") }}</h3>
          <div class="options-list">
            <div class="options-list__item options-list__item--dropdown" v-for="(invoice, index) in memberInvoices">
              <div class="options-list__content">
                <h4 class="options-list__title">{{ Format.money(invoice.total) }}</h4>
              </div>
              <div class="options-list__control">
                <dropdown
                  :label="generateDropdownLabel(invoice)"
                  :links="generateDropdownActions(invoice)"
                  :isNotSync="true"
                  :acc="acc.generate('invoice-action', Format.money(invoice.total))"

                  @markAsPaid="changeStatus(invoice, 20)"
                  @markAsUnPaid="changeStatus(invoice, 10)"
                  @deleteInvoice="deleteInvoice(invoice)" />
                </dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  </article>
</template>

<script>
import Format from 'services/Format'
import { mapGetters } from 'vuex'
import L from 'services/Localization'
import Submenu from 'components/views/members/Submenu'
import { Btn, SelectList } from 'components/layout/forms'
import Dropdown from 'components/partials/Dropdown'
import acc from 'services/Acceptance'

export default {
  name: 'member-subscriptions',
  components: { Submenu, Btn, SelectList, Dropdown },
  data() {
    return {
      L: L,
      Format: Format,
      selectPaymentOptionId: '',
      acc: acc
    }
  },
  created() {
    if (this.$route.params.id) {
      this.$store.dispatch('getPaymentOptions').then(() => {
        this.selectPaymentOptionId = this.paymentOptions[0].id
      })
      this.$store.dispatch('getMember', this.$route.params.id)
      this.$store.dispatch('getHistory', this.$route.params.id)
    }
  },
  computed: {
    ...mapGetters({
      member: 'activeMember',
      paymentOptions: 'allPaymentOptions',
      memberInvoices: 'memberInvoices',
      memberPaymentOptions: 'memberPaymentOptions'
    }),
    paymentOptionsOptions() {
      return this.paymentOptions.map((option) => {
        return {
          value: option.id,
          label: option.name
        }
      })
    }
  },
  methods: {
    generateDropdownLabel: function (invoice) {
      return invoice.status === 10 ? L.localize('UnPaid') : L.localize('Paid')
    },
    generateDropdownActions: function (invoice) {
      let links = []
      links.push({
        label: L.localize('Label_Invoice'),
        url: { name: 'member-invoice', params: { id: this.member.id, invoiceId: invoice.id } },
        acc: acc.generate('invoice', Format.money(invoice.total))
      })
      if (invoice.status === 10) {
        links.push({
          label: L.localize('Invoice_MarkAsPaid'),
          url: 'markAsPaid',
          asFunction: true,
          bypassRouter: true,
          acc: acc.generate('change-status', Format.money(invoice.total))
        })
      } else {
        links.push({
          label: L.localize('Invoice_MarkAsUnPaid'),
          url: 'markAsUnPaid',
          asFunction: true,
          bypassRouter: true,
          acc: acc.generate('change-status', Format.money(invoice.total))
        })
      }
      links.push({
        label: L.localize('Label_Delete'),
        url: 'deleteInvoice',
        asFunction: true,
        bypassRouter: true,
        acc: acc.generate('delete', Format.money(invoice.total))
      })
      return links
    },
    addSubscription: function (paymentOptionId) {
      let request = { memberId: this.member.id, paymentOptionId: paymentOptionId }
      this.$store.dispatch('assignSubscription', request).then(() => {
        this.$store.dispatch('createInvoice', request)
      })
    },
    cancelSubscription: function (paymentOptionId) {
      let request = { memberId: this.member.id, paymentOptionId: paymentOptionId }
      this.$store.dispatch('cancelSubscription', request)
    },
    changeStatus: function (invoice, status) {
      let request = { invoiceId: invoice.id, status, memberId: this.member.id }
      this.$store.dispatch('changeInvoiceStatus', request)
    },
    deleteInvoice: function (invoice) {
      let request = { invoiceId: invoice.id, memberId: this.member.id }
      this.$store.dispatch('deleteInvoice', request)
    }
  }
}
</script>

<style lang='scss'>

</style>



// WEBPACK FOOTER //
// MemberSubscriptions.vue?70bd2aa1